import { graphql } from "react-relay";

// components
import "@components/onboarding-chrome-autopilot/OnboardingChromeAutopilot.gql";

export const fragments = {
  user: graphql`
    fragment OnboardingAutopilotStepRenderer_user on User {
      id
      emails
    }
  `,
  org: graphql`
    fragment OnboardingAutopilotStepRenderer_org on Org
    @argumentDefinitions(timeZone: { type: "String!" }) {
      id
      experiments
      primaryOrgCalendar
      autopilotEventsResponse(timeZone: $timeZone) {
        __typename
        ... on AutopilotEventsResponse {
          enabledOrganized {
            ...OnboardingAutopilotEvent_event
            calendarIds
            title
            annotatedEvent {
              id
              userTags {
                tag
                states {
                  value
                  subjectType
                  subjectValue
                  lastModified
                  active
                }
              }
              orgTags {
                tag
                state {
                  value
                  subjectType
                  subjectValue
                  lastModified
                  active
                }
              }
            }
            annotatedRecurringEvent {
              id
              userTags {
                tag
                states {
                  value
                  subjectType
                  subjectValue
                  lastModified
                  active
                }
              }
              orgTags {
                tag
                state {
                  active
                  value
                  subjectType
                  subjectValue
                  lastModified
                }
              }
            }
            createdMillis
            eventKey {
              externalEventId
            }
            organizer {
              urnValue
            }
            attendees {
              urnValue
            }
            startTime {
              millis
            }
            endTime {
              millis
            }
            suggestedAutopilotSettingsResponseV3 {
              __typename
              ... on SuggestedAutopilotSettingsResponseV3 {
                intersectionOfAttendeesMeetingHours {
                  minSlot {
                    dayOffset
                    timeSlot
                  }
                  maxSlot {
                    dayOffset
                    timeSlot
                  }
                }
                calendarIdToMeetingHours {
                  calendarId
                  dayOffsetTimeSlotRanges {
                    minSlot {
                      dayOffset
                      timeSlot
                    }
                    maxSlot {
                      dayOffset
                      timeSlot
                    }
                  }
                }
                suggestedAutopilotSettings {
                  isRoomFlexible
                  movementType
                  allowedEndTime {
                    dayOffset
                    timeSlot
                  }
                  allowedStartTime {
                    dayOffset
                    timeSlot
                  }
                }
              }
              ... on GraphEntityError {
                message
              }
            }
            moveRangeInLocalTimeV3 {
              __typename
              ... on MoveRangeInLocalTimeV3 {
                allowedStartTimeInclusive {
                  dayOffset
                  timeSlot
                }
                allowedEndTimeInclusive {
                  dayOffset
                  timeSlot
                }
              }
              ... on GraphEntityError {
                message
              }
            }
          }
          enabledAttending {
            ...OnboardingAutopilotEvent_event
            calendarIds
            title
            annotatedEvent {
              id
              userTags {
                tag
                states {
                  value
                  subjectType
                  subjectValue
                  lastModified
                  active
                }
              }
              orgTags {
                tag
                state {
                  value
                  subjectType
                  subjectValue
                  lastModified
                  active
                }
              }
            }
            annotatedRecurringEvent {
              id
              userTags {
                tag
                states {
                  value
                  subjectType
                  subjectValue
                  lastModified
                  active
                }
              }
              orgTags {
                tag
                state {
                  active
                  value
                  subjectType
                  subjectValue
                  lastModified
                }
              }
            }
            createdMillis
            eventKey {
              externalEventId
            }
            organizer {
              urnValue
              displayName
            }
            attendees {
              urnValue
            }
            startTime {
              millis
            }
            endTime {
              millis
            }
            suggestedAutopilotSettingsResponseV3 {
              __typename
              ... on SuggestedAutopilotSettingsResponseV3 {
                intersectionOfAttendeesMeetingHours {
                  minSlot {
                    dayOffset
                    timeSlot
                  }
                  maxSlot {
                    dayOffset
                    timeSlot
                  }
                }
                calendarIdToMeetingHours {
                  calendarId
                  dayOffsetTimeSlotRanges {
                    minSlot {
                      dayOffset
                      timeSlot
                    }
                    maxSlot {
                      dayOffset
                      timeSlot
                    }
                  }
                }
                suggestedAutopilotSettings {
                  isRoomFlexible
                  movementType
                  allowedEndTime {
                    dayOffset
                    timeSlot
                  }
                  allowedStartTime {
                    dayOffset
                    timeSlot
                  }
                }
              }
              ... on GraphEntityError {
                message
              }
            }
            moveRangeInLocalTimeV3 {
              __typename
              ... on MoveRangeInLocalTimeV3 {
                allowedStartTimeInclusive {
                  dayOffset
                  timeSlot
                }
                allowedEndTimeInclusive {
                  dayOffset
                  timeSlot
                }
              }
              ... on GraphEntityError {
                message
              }
            }
          }
          suggestedOrganized {
            ...OnboardingAutopilotEvent_event
            calendarIds
            title
            annotatedEvent {
              id
              userTags {
                tag
                states {
                  value
                  subjectType
                  subjectValue
                  lastModified
                  active
                }
              }
              orgTags {
                tag
                state {
                  value
                  subjectType
                  subjectValue
                  lastModified
                  active
                }
              }
            }
            annotatedRecurringEvent {
              id
              userTags {
                tag
                states {
                  value
                  subjectType
                  subjectValue
                  lastModified
                  active
                }
              }
              orgTags {
                tag
                state {
                  active
                  value
                  subjectType
                  subjectValue
                  lastModified
                }
              }
            }
            createdMillis
            eventKey {
              externalEventId
            }
            organizer {
              urnValue
            }
            attendees {
              urnValue
            }
            startTime {
              millis
            }
            endTime {
              millis
            }
            suggestedAutopilotSettingsResponseV3 {
              __typename
              ... on SuggestedAutopilotSettingsResponseV3 {
                intersectionOfAttendeesMeetingHours {
                  minSlot {
                    dayOffset
                    timeSlot
                  }
                  maxSlot {
                    dayOffset
                    timeSlot
                  }
                }
                calendarIdToMeetingHours {
                  calendarId
                  dayOffsetTimeSlotRanges {
                    minSlot {
                      dayOffset
                      timeSlot
                    }
                    maxSlot {
                      dayOffset
                      timeSlot
                    }
                  }
                }
                suggestedAutopilotSettings {
                  isRoomFlexible
                  movementType
                  allowedEndTime {
                    dayOffset
                    timeSlot
                  }
                  allowedStartTime {
                    dayOffset
                    timeSlot
                  }
                }
              }
              ... on GraphEntityError {
                message
              }
            }
            moveRangeInLocalTimeV3 {
              __typename
              ... on MoveRangeInLocalTimeV3 {
                allowedStartTimeInclusive {
                  dayOffset
                  timeSlot
                }
                allowedEndTimeInclusive {
                  dayOffset
                  timeSlot
                }
              }
              ... on GraphEntityError {
                message
              }
            }
          }
          suggestedAttending {
            ...OnboardingAutopilotEvent_event
            title
            calendarIds
            annotatedEvent {
              id
              userTags {
                tag
                states {
                  value
                  subjectType
                  subjectValue
                  lastModified
                  active
                }
              }
              orgTags {
                tag
                state {
                  value
                  subjectType
                  subjectValue
                  lastModified
                  active
                }
              }
            }
            annotatedRecurringEvent {
              id
              userTags {
                tag
                states {
                  value
                  subjectType
                  subjectValue
                  lastModified
                  active
                }
              }
              orgTags {
                tag
                state {
                  active
                  value
                  subjectType
                  subjectValue
                  lastModified
                }
              }
            }
            createdMillis
            eventKey {
              externalEventId
            }
            organizer {
              urnValue
            }
            attendees {
              urnValue
            }
            startTime {
              millis
            }
            endTime {
              millis
            }
            suggestedAutopilotSettingsResponseV3 {
              __typename
              ... on SuggestedAutopilotSettingsResponseV3 {
                intersectionOfAttendeesMeetingHours {
                  minSlot {
                    dayOffset
                    timeSlot
                  }
                  maxSlot {
                    dayOffset
                    timeSlot
                  }
                }
                calendarIdToMeetingHours {
                  calendarId
                  dayOffsetTimeSlotRanges {
                    minSlot {
                      dayOffset
                      timeSlot
                    }
                    maxSlot {
                      dayOffset
                      timeSlot
                    }
                  }
                }
                suggestedAutopilotSettings {
                  isRoomFlexible
                  movementType
                  allowedEndTime {
                    dayOffset
                    timeSlot
                  }
                  allowedStartTime {
                    dayOffset
                    timeSlot
                  }
                }
              }
              ... on GraphEntityError {
                message
              }
            }
            moveRangeInLocalTimeV3 {
              __typename
              ... on MoveRangeInLocalTimeV3 {
                allowedStartTimeInclusive {
                  dayOffset
                  timeSlot
                }
                allowedEndTimeInclusive {
                  dayOffset
                  timeSlot
                }
              }
              ... on GraphEntityError {
                message
              }
            }
          }
        }
        ... on GraphEntityError {
          message
        }
      }
      ...OnboardingChromeAutopilot_org @arguments(timeZone: $timeZone)
    }
  `,
};
